module.exports = __webpack_public_path__ + "static/img/h1.b6f68e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Hridya/Hridya-pics/h1.jpg
// module id = lojV
// module chunks = 0